<template>
  <div class="flex items-center gap-2 sm:gap-4 w-full justify-between">
    <div class="flex items-center gap-2 sm:gap-4">
      <BuildingOffice2Icon :class="step > 1 ? 'text-pdsPrimaryColor' : 'text-gray-300'" class="h-6 w-6 flex-shrink-0" />
      <div
        :class="step > 1 ? 'text-pdsPrimaryColor' : 'text-gray-300'"
        class="font-bold text-xl leading-snug"
      >
        Organisaties & afdelingen 
      </div>
    </div>
    <div
      v-if="editInstitutionAndDepartment && step >= 2"
      class="cursor-pointer text-pdsPrimaryColor text-sm font-semibold"
      @click="editInstitutionDetails"
    >
      Wijzigen
    </div>
  </div>
  <!--agb flow -->
  <template v-if="step == 2 && lookupCodeType === 'agb' && !showSavedInstitutionDetail && !selectedDepartment">
    <div class="mt-2 flex flex-col">
      <div>
        <Alert
          class="mt-2"
          v-if="errorMessage.show"
          :html="true"
          :type="errorMessage.type"
          :htmlMessage="errorMessage.text"
        />
      </div>
    </div>
    <div class="font-semibold text-cyan-900 mb-2 mt-1" v-html="institutionSelectionHeading"></div>
    <div
      v-if="institutionDetails && institutionDetails.length > 1 && departmentsDetails == ''"
      :class="institutionDetails && institutionDetails.length > 10 ? 'max-h-96 overflow-y-auto pr-4 mt-2' : ''"
      class="w-full max-w-3xl mx-auto mt-2"
    >
      <div
        v-for="(institution, index) in institutionDetails"
        :key="index"
        :class="['flex flex-col sm:flex-row sm:items-center justify-between pt-1 w-full', index !== 0 ? 'mt-1' : '']"
      >
        <div
          class="flex items-center justify-between w-full text-gray-700 hover:text-pdsPrimaryColor transition-colors duration-150 cursor-pointer"
          @click="searchInstitutionByAgbFlow(institution)"
        >
          <div class="font-normal text-sm leading-6 break-words whitespace-normal">
            {{ institution.Name }}
            <div>{{ institution.Agbcode }}</div>
          </div>
          <div class="font-normal text-sm leading-6 font-semibold text-pdsPrimaryColor whitespace-nowrap">
            Selecteren
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="departmentsDetails && departmentsDetails.length > 0"
      :class="departmentsDetails && departmentsDetails.length > 10 ? 'max-h-96 overflow-y-auto pr-4' : ''"
      class="w-full max-w-3xl mx-auto text-gray-700"
    >
      <div
        v-for="(department, index) in departmentsDetails"
        :key="index"
        :class="[
          'flex flex-col sm:flex-row sm:items-center justify-between pt-1 w-full hover:text-pdsPrimaryColor transition-colors duration-150 cursor-pointer',
          index !== 0 ? 'mt-1' : ''
        ]"
      >
        <div class="flex items-center justify-between gap-2 w-full" @click="addDepartment(department)">
          <div class="font-normal text-sm leading-6 break-words whitespace-normal">
            {{ department.Name }}
          </div>
          <div
            class="font-normal text-sm leading-6 font-semibold text-pdsPrimaryColor hover:underline cursor-pointer whitespace-nowrap"
          >
            Selecteren
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="departmentsDetails.length > 0 && showDepartmentNotInListOption"
      class="w-full max-w-3xl mx-auto font-bold text-sm leading-6 text-pdsPrimaryColor underline cursor-pointer mt-1 mb-1"
      @click.prevent="departmentNotInList(selectedInstitution)"
    >
      Mijn afdeling staat er niet tussen
    </div>
  </template>
  <!--big flow -->
  <template v-if="step == 2 && (lookupCodeType === 'big' || lookupCodeType === 'Kp') && !showSavedInstitutionDetail && !selectedDepartment">
    <div class="mt-2 flex flex-col">
      <label class="font-bold text-base leading-6 text-cyan-900 mt-2"> AGB-code van de organisatie </label>
      <div class="flex items-center gap-2 w-full">
        <input-groups
          class="w-1/2"
          id="institutionAgb"
          v-model="details.institutionAgb"
          placeholder="AGB-nummer"
          :rules="{ required: true, regex: /^[0-9]{8}$/ }"
        />
        <button
          type="button"
          :disabled="!disabled"
          :class="{
            'text-white bg-gray-300 border-gray-300 cursor-not-allowed': !disabled,
            'text-white bg-pdsPrimaryColor border-pdsPrimaryColor': disabled
          }"
          class="relative flex items-center px-5 py-2 justify-center mb-2 text-white rounded-full border w-32 h-10"
          @click.prevent="searchInstitution('internal', details.institutionAgb, '')"
        >
          <span class="mx-auto">Zoeken</span>
          <MagnifyingGlassIcon class="w-5 h-5 text-white ml-2 absolute right-4" />
        </button>
      </div>
      <div>
        <Alert
          class="mt-2"
          v-if="errorMessage.show"
          :html="true"
          :type="errorMessage.type"
          :htmlMessage="errorMessage.text"
        />
      </div>
    </div>
    <div class="font-semibold text-cyan-900 mb-2 mt-1" v-if="departmentsDetails && departmentsDetails.length > 0">
      Voor <span class="font-bold"> {{ institutionName }} </span>hebben wij meerdere afdelingen gevonden. Selecteer de
      afdeling(en) waar u werkt.
    </div>
    <div
      :class="departmentsDetails && departmentsDetails.length > 10 ? 'max-h-96 overflow-y-auto pr-4' : ''"
      class="w-full mx-auto text-gray-700"
    >
      <div
        v-for="(department, index) in departmentsDetails"
        :key="index"
        :class="[
          'flex flex-col sm:flex-row sm:items-center justify-between pt-1 w-full hover:text-pdsPrimaryColor transition-colors duration-150 cursor-pointer',
          index !== 0 ? 'mt-1' : ''
        ]"
      >
        <div class="flex items-center justify-between gap-2 w-full" @click="addDepartment(department)">
          <div class="font-normal text-sm leading-6 break-words whitespace-normal">
            {{ department.Name }}
          </div>
          <div
            class="text-sm leading-6 font-semibold text-pdsPrimaryColor hover:underline cursor-pointer whitespace-nowrap"
          >
            Selecteren
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="departmentsDetails.length > 0 && showDepartmentNotInListOption"
      class="w-full max-w-3xl mx-auto font-bold text-sm leading-6 text-pdsPrimaryColor underline cursor-pointer mt-1 mb-1"
      @click.prevent="departmentNotInList(details)"
    >
      Mijn afdeling staat er niet tussen
    </div>
  </template>
  <!--warranter flow -->
  <template v-if="step == 2 && lookupCodeType === 'agbOrBig' && !showSavedInstitutionDetail && !selectedDepartment">
    <div class="mt-2 flex flex-col">
      <div>
        <Alert
          class="mt-2"
          v-if="errorMessage.show"
          :html="true"
          :type="errorMessage.type"
          :htmlMessage="errorMessage.text"
        />
      </div>
    </div>
    <div
      v-if="departmentsDetails && departmentsDetails.length > 0"
      class="mt-2 font-bold text-base leading-6 text-cyan-900"
    >
      Uw volmachtgever werkt bij
    </div>
    <div
      v-if="departmentsDetails && departmentsDetails.length > 0"
      :class="departmentsDetails && departmentsDetails.length > 10 ? 'max-h-96 overflow-y-auto pt-1 pr-4' : ''"
      class="w-full max-w-3xl pt-1 mx-auto text-gray-700"
    >
      <div
        v-for="(detail, index) in departmentsDetails"
        :key="index"
        :class="[
          'flex flex-col sm:flex-row sm:items-center justify-between pt-1 w-full hover:text-pdsPrimaryColor transition-colors duration-150 cursor-pointer',
          index !== 0 ? 'mt-1' : ''
        ]"
      >
        <div class="flex items-center justify-between w-full" @click="addDepartment(detail.Department)">
          <div class="font-normal text-sm leading-6 break-words whitespace-normal">
            <span class="font-bold text-gray-900">{{ detail.Department.Institution.Name }}</span> -
            <span class="text-sm">{{ detail.Department.Name }}</span>
          </div>
          <div
            class="text-sm leading-6 font-semibold text-pdsPrimaryColor hover:underline cursor-pointer whitespace-nowrap"
          >
            Selecteren
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-if="step == 2 && saveDepartment && !showSavedInstitutionDetail">
    <div class="mt-1 flex flex-col">
      <label class="font-bold text-base leading-6 text-cyan-900 mt-4">
        De volgende organisatie en afdeling worden toegenvoegd aan uw account:
      </label>
      <div
        class="flex flex-col sm:flex-row sm:items-center justify-between pt-1 w-full mt-1"
        v-if="selectedInstitution && selectedDepartment"
      >
        <div class="flex items-center justify-between gap-2 w-full">
          <div class="text-gray-700 text-sm sm:text-base break-words whitespace-normal">
            <span class="font-bold text-base leading-6 text-cyan-900">{{ selectedInstitution.Name }}</span> -
            <span class="text-sm">{{ selectedDepartment.Name }}</span>
          </div>
          <div
            class="text-lg sm:text-base font-semibold text-pdsPrimaryColor hover: cursor-pointer whitespace-nowrap"
            @click="editInstitutionDetails()"
          >
            <PencilIcon class="w-5 h-5 right-4" />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between gap-2 w-full">
        <div
          class="text-gray-700 text-sm sm:text-base break-words whitespace-normal"
          v-if="editInstitutionAndDepartment"
        >
          <span class="font-bold text-gray-900">{{ departmentEmail }}</span>
        </div>
      </div>
      <div class="flex flex-col w-full mt-4" v-if="!editInstitutionAndDepartment">
        <label class="font-semibold text-sm leading-6 text-cyan-900">
          Uw persoonlijke e-mailadres binnen de afdeling*
        </label>
        <label>
          <input
            class="font-normal text-sm leading-6"
            type="checkbox"
            v-model="setDefaultEmailChecked"
            @change="setPersonalEmailAsDepartmentEmail($event.target.checked)"
          />
          Dit is hetzelfde als mijn persoonlijke e-mailadres
        </label>
        <input-groups
          class="w-1/2"
          id="alternateDepartmentEmail"
          v-model:value="alternateDepartmentEmail"
          @update:model-value="(val) => (alternateDepartmentEmail = val)"
          placeholder="voornaam.achternaam@domein.nl"
          :rules="{ required: true, isEmail: true }"
          :disabled="setDefaultEmailChecked"
          :errorWrapper="false"
        />
      </div>
      <div v-if="!editInstitutionAndDepartment">
        <button
          type="button"
          @click="saveInstitutionAndDepartment()"
          :disabled = "!alternateDepartmentEmail"
          :class="{
                  'text-white bg-pdsPrimaryColor cursor-pointer border-pdsPrimaryColor': alternateDepartmentEmail,
                  'text-white bg-gray-300 border-gray-300 cursor-default': !alternateDepartmentEmail
                  }" 
          class="text-center mt-2 text-white cursor-pointer rounded-full border w-32 h-10"
        >
          Doorgaan 
        </button>
      </div>
      <div class="mt-2 flex flex-col">
        <Alert
          class="mt-2 w-[32rem] max-w-full"
          :html="true"
          type="info"
          :htmlMessage="'U kunt uw account registreren onder 1 organisatie. Als uw account is aangemaakt kunt u daarna makkelijk zelf meerdere organisaties en/of afdelingen toevoegen.'"
        />
      </div>
    </div>
  </template>
  <template v-if="step >= 2 && showSavedInstitutionDetail">
    <div class="mt-2 text-gray-700 text-sm break-words whitespace-normal">
      <label class="font-bold text-base leading-6 text-cyan-900 mt-4">
        De volgende organisatie en afdeling worden toegenvoegd aan uw account:
      </label>
      <div v-if="selectedInstitution.Name" class="font-bold">
        {{ selectedInstitution.Name }}
      </div>
      <div v-if="details?.institutions">
        <div v-if="details?.institutions[0]?.phoneNumber">
          {{ details.institutions[0].phoneNumber }}
        </div>
        <div v-if="details?.institutions[0]?.houseNumber && details?.institutions[0]?.streetName">
          {{ details.institutions[0].houseNumber }} {{ details.institutions[0].streetName }}
        </div>
        <div v-if="details.institutions[0]?.city">
          {{ details.institutions[0].city }}
        </div>
        <div v-if="details.institutions[0]?.email">
          {{ details.institutions[0].email }}
        </div>
      </div>
      <div v-if="selectedDepartment.Name" class="mt-4 font-bold">
        {{ selectedDepartment.Name }}
      </div>
      <div v-if="departmentEmail">
        {{ departmentEmail }}
      </div>
      <div class="flex flex-col mt-1" v-if="alternateDepartmentEmail">
        <label class="font-bold text-sm leading-6 text-cyan-900">Uw persoonlijk e-mailadres binnen de afdeling:</label>
        <span> {{ alternateDepartmentEmail }}</span>
      </div>
    </div>
  </template>
</template>

<script>
import { BuildingOffice2Icon, MagnifyingGlassIcon, PencilIcon } from '@heroicons/vue/24/outline';
import { useForm } from 'vee-validate';
import { useStore } from 'vuex';
import { ref, computed, watchEffect, watch } from 'vue';

export default {
  name: 'AccountRegistrationInstitutionDetail',
  components: { BuildingOffice2Icon, MagnifyingGlassIcon, PencilIcon },
  props: {
    details: {
      type: Object
    },
    step: { type: Number, default: 0 },
    lookupCodeType: { type: String, default: '' }
  },

  emits: ['setInstitutionDetails'],

  setup(props, { emit }) {
    const { validate } = useForm();
    const store = useStore();
    const institutionDetails = ref([]);
    const institutionName = ref();
    const departmentsDetails = ref([]);
    const filteredDepartmentsDetails = ref([]);
    const showDepartmentNotInListOption = ref(true);
    const showSavedInstitutionDetail = ref(false);
    const errorMessage = ref({
      text: '',
      type: '',
      show: false
    });
    const selectedDepartment = ref(null);
    const selectedInstitution = ref(null);
    const saveDepartment = ref(false);
    const departmentEmail = ref(null);
    const alternateDepartmentEmail = ref('');
    const editInstitutionAndDepartment = ref(false);
    const institutionSelectionHeading = ref('Selecteer hieronder uw instelling of praktijk');
    const setDefaultEmailChecked = ref(false);
    const addInstitutionDetails = (data) => store.commit('accountRegistration/addInstitutionDetails', data);
    const addDepartmentDetails = (data) => store.commit('accountRegistration/addDepartmentDetails', data);
    const setInstitutionDetails = (step) => {
      emit('setInstitutionDetails', step);
    };
    const disabled = computed(() => {
      return /^[0-9]{8}$/.test(props.details.institutionAgb);
    });
    // this is flow when user search with big initially
    const searchInstitution = (method, code, lookupCodeType) => {
      let codeDetails = { code: code, lookUpType: method, lookupCodeType: lookupCodeType };
      store.dispatch('accountRegistration/fetchInstitution', codeDetails).then((response) => {
        if (response && response.Name) {
          institutionName.value = response.Name;
          selectedInstitution.value = response;
          departmentsDetails.value = response.Department;
          filteredDepartmentsDetails.value = response.Department;
          if (method == 'internal') {
            showDepartmentNotInListOption.value = true;
          } else {
            showDepartmentNotInListOption.value = false;
          }
          resetErrormessage();
        } else {
          errorMessage.value.text = 'AGB-code is niet bekend in het AGB-register';
          errorMessage.value.type = 'error';
          errorMessage.value.show = true;
          resetInstitutionDetails();
        }
      });
    };
    // to get user institution in case of agb serach , if he works for only one then get all departmensts
    const searchUserInstitutionRelationByAgbFlow = (code) => {
      resetInstitutionDetails();
      store.dispatch('accountRegistration/fetchUserInstitutionRelation', code).then((response) => {
        if (response && response.Name) {
          institutionDetails.value = response.Institution;
          institutionName.value = response.Institution[0].Name;
          departmentsDetails.value = '';
          institutionSelectionHeading.value = 'Selecteer hieronder uw instelling of praktijk';
          filteredDepartmentsDetails.value = '';
          // if user works for only one institution then get that institutions's departments from local db
          if (response.Institution && response.Institution.length == 1) {
            institutionName.value = response.Institution[0].Name;
            institutionSelectionHeading.value =
              "Voor <span class='font-bold'> " +
              response.Institution[0].Name +
              ' </span> hebben wij meerdere afdelingen gevonden. Selecteer de afdeling(en) waar u werkt.';
            selectedInstitution.value = response.Institution[0];
            addInstitutionDetails(response.Institution);
            searchInstitutionByAgbFlow(response.Institution[0]);
          }
          resetErrormessage();
        } else {
          errorMessage.value.text = 'AGB-code is niet bekend in het AGB-register';
          errorMessage.value.type = 'error';
          errorMessage.value.show = true;
          resetInstitutionDetails();
        }
      });
    };
    // to get warranter departments
    const searchInstitutionRelationByWarranterFlow = (code) => {
      resetInstitutionDetails();
      store.dispatch('accountRegistration/fetchWarranterDepartments', code).then((response) => {
        if (response.length > 0) {
          departmentsDetails.value = response;
          filteredDepartmentsDetails.value = response;
          resetErrormessage();
        } else {
          errorMessage.value.text =
            'De geselecteerde volmachtgever is niet geregistreerd onder een Instelling en/of afdeling bij Mediq. Laat de volmachtgever contact opnemen met Mediq of kies een andere volmachtgever wanneer mogelijk';
          errorMessage.value.type = 'error';
          errorMessage.value.show = true;
        }
      });
    };
    const searchInstitutionByAgbFlow = (institutionDetail) => {
      selectedInstitution.value = institutionDetail;
      let codeDetails = { code: institutionDetail.Agbcode, lookUpType: 'internal', lookupCodeType: 'agb' };
      institutionSelectionHeading.value =
        "Voor <span class='font-bold'> " +
        institutionDetail?.Name +
        ' </span> hebben wij meerdere afdelingen gevonden. Selecteer de afdeling(en) waar u werkt.';
      store.dispatch('accountRegistration/fetchInstitution', codeDetails).then((response) => {
        if (response && response.Name) {
          institutionName.value = response.Name;
          departmentsDetails.value = response.Department;
          filteredDepartmentsDetails.value = response.Department;
        } else {
          searchDepartmentsByAgbFlow(institutionDetail.Agbcode);
        }
      });
    };
    const getInstitutionDetail = () => {
      let code =
        props.lookupCodeType === 'agb'
          ? selectedInstitution.value.Agbcode
          : props.lookupCodeType === 'agbOrBig'
          ? selectedInstitution.value.InstitutionId
          : selectedInstitution.value.AgbCode;

      let codeDetails = { code: code, lookUpPharseType: props.lookupCodeType };

      store.dispatch('accountRegistration/fetchInstitutionDetail', codeDetails).then((response) => {
        if (response && response.Name) {
          addInstitutionDetails(response);
        } else {
          let institition = { Name: selectedInstitution.value.Name, AgbCode: code };
          addInstitutionDetails(institition);
        }
        let department = { Name: selectedDepartment.value.Name, Email: departmentEmail.value };
        addDepartmentDetails(department);
      });
    };
    const searchDepartmentsByAgbFlow = (code) => {
      store.dispatch('accountRegistration/fetchDepartments', code).then((response) => {
        if (response && response.Name) {
          resetErrormessage();
          institutionName.value = response.Name;
          departmentsDetails.value = response.Department;
          filteredDepartmentsDetails.value = response.Department;
        } else {
          errorMessage.value.text = 'Geen afdeling gevonden onder deze instelling';
          errorMessage.value.type = 'error';
          errorMessage.value.show = true;
        }
      });
    };
    // search by vektis if department is not in the list of internal departments
    const departmentNotInList = (details) => {
      let code = details.AgbCode ? details.AgbCode : details.Agbcode;
      if (props.lookupCodeType && props.lookupCodeType === 'agb') {
        searchDepartmentsByAgbFlow(code);
      } else {
        searchInstitution('external', details.institutionAgb);
      }
      showDepartmentNotInListOption.value = false;
    };
    const editInstitutionDetails = () => {
      if (props.lookupCodeType === 'agbOrBig') {
        searchInstitutionRelationByWarranterFlow(props.details.agbOrBigCode);
      } else if (props.lookupCodeType === 'agb') {
        searchUserInstitutionRelationByAgbFlow(props.details.agbCode);
      } else {
        departmentsDetails.value = '';
      }
      showDepartmentNotInListOption.value = true;
      showSavedInstitutionDetail.value = false;
      saveDepartment.value = false;
      departmentEmail.value = '';
      editInstitutionAndDepartment.value = false;
      selectedDepartment.value = '';
      selectedInstitution.value = '';
      alternateDepartmentEmail.value = '';
      setDefaultEmailChecked.value = false;
      setInstitutionDetails(2);
    };
    const resetErrormessage = () => {
      errorMessage.value.text = '';
      errorMessage.value.type = '';
      errorMessage.value.show = false;
    };
    const resetInstitutionDetails = () => {
      institutionDetails.value = '';
      institutionName.value = '';
      departmentsDetails.value = '';
      filteredDepartmentsDetails.value = '';
      selectedDepartment.value = '';
      saveDepartment.value = false;
      showSavedInstitutionDetail.value = false;
      alternateDepartmentEmail.value = '';
      departmentEmail.value = '';
      editInstitutionAndDepartment.value = false;
      setDefaultEmailChecked.value = false;
    };
    const saveInstitutionAndDepartment = async () => {
      const result = await validate();
      if (result.valid || alternateDepartmentEmail.value) {
        editInstitutionAndDepartment.value = true;
        showSavedInstitutionDetail.value = true;
        getInstitutionDetail();
        // in agb flow there is one more step before save
        savePrescriberInstitution();
        editInstitutionAndDepartment.value = true;
      } else {
        editInstitutionAndDepartment.value = false;
      }
    };
    const addDepartment = (department) => {
      if (props.lookupCodeType === 'agbOrBig') {
        selectedInstitution.value = department.Institution;
        selectedDepartment.value = department;
        departmentsDetails.value = departmentsDetails.value.filter((d) => d.DepartmentId !== department.DepartmentId);
      } else {
        selectedDepartment.value = department;
        departmentsDetails.value = departmentsDetails.value.filter((d) => d !== department);
      }
      saveDepartment.value = true;
      addDepartmentDetails(department);
    };
    const savePrescriberInstitution = () => {
      setInstitutionDetails(3);
    };
    const setPersonalEmailAsDepartmentEmail = (isSelected) => {
      if (isSelected) {
        if (props.details.email) {
          alternateDepartmentEmail.value = props.details.email;
          setDefaultEmailChecked.value = true;
        } else {
          setDefaultEmailChecked.value = false;
        }
      } else {
        setDefaultEmailChecked.value = false;
        alternateDepartmentEmail.value = '';
      }
    };
    watchEffect(() => {
      if (props.lookupCodeType != null && props.lookupCodeType === 'agb' && props.details.agbCode) {
        searchUserInstitutionRelationByAgbFlow(props.details.agbCode);
      } else if (props.lookupCodeType != null && props.lookupCodeType === 'agbOrBig' && props.details.agbOrBigCode) {
        searchInstitutionRelationByWarranterFlow(props.details.agbOrBigCode);
      } else if (props.lookupCodeType == 'big') {
        resetInstitutionDetails();
      }
    });
    return {
      addDepartment,
      setInstitutionDetails,
      searchInstitution,
      institutionDetails,
      departmentsDetails,
      institutionName,
      errorMessage,
      disabled,
      searchInstitutionByAgbFlow,
      departmentNotInList,
      showDepartmentNotInListOption,
      departmentEmail,
      saveDepartment,
      selectedDepartment,
      selectedInstitution,
      saveInstitutionAndDepartment,
      editInstitutionAndDepartment,
      editInstitutionDetails,
      showSavedInstitutionDetail,
      alternateDepartmentEmail,
      savePrescriberInstitution,
      setDefaultEmailChecked,
      setPersonalEmailAsDepartmentEmail,
      institutionSelectionHeading
    };
  }
};
</script>
